function isPromise(obj) {
	if (obj && typeof obj.then === "function") return true;
	return false;
}

const axiosMiddleware = store => next => action => {
	if (isPromise(action.payload)) {
		action.payload.then(res => {
			next(action);
		});
	} else {
		next(action);
	}
	return;
};

export default axiosMiddleware;



// WEBPACK FOOTER //
// ./src/middleware.js